import { createContext, useContext, ReactNode } from 'react';
import { PreApprovalDto } from '@servicetitan/financing-api-client/src/prequals-api';

export interface PreApprovalStoreValue {
    preApproval: PreApprovalDto | null;
    isLoading: boolean;
}

/**
 * The pre-approval opt-in seam.
 *
 * Hand-rolled (not via the shared `createStore`) on purpose: `createStore`'s `useStore()` throws
 * when no provider is mounted, and its context is private. Non-opted-in MFEs render `PlansList`
 * without mounting this provider, so the store must default to "no pre-approval" rather than throw.
 * React returns this default context value when no provider is present, giving the opt-in seam its
 * null-safe read with no change to the global store contract.
 */
const PreApprovalContext = createContext<PreApprovalStoreValue>({
    preApproval: null,
    isLoading: false,
});

export const PreApprovalStore = {
    Provider: ({
        preApproval,
        isLoading = false,
        children,
    }: {
        preApproval: PreApprovalDto | null;
        isLoading?: boolean;
        children: ReactNode;
    }) => (
        <PreApprovalContext.Provider value={{ preApproval, isLoading }}>
            {children}
        </PreApprovalContext.Provider>
    ),
    useStore: (): PreApprovalStoreValue => useContext(PreApprovalContext),
};
